import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { IP_BOARD_PART_TYPE_CHOICES } from 'src/app/model/product/ip-board/ip-board-part-type';
import { ClientIPBoardAndPlacementHelper } from './client-ip-board-and-placement-helper';

export class ClientIPBoardPartFormHelper {
  public static readonly CUSTOM_SIGN_IP_DIMENSION_OPTIONS = {
    LYING_DOWN: {
      label: 'Liggende lay-out',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal
        ) {
          ipBoardPart.otherHeight = 70;
          ipBoardPart.otherWidth = 100;
          return;
        }
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
        ) {
          ipBoardPart.otherHeight = 100;
          ipBoardPart.otherWidth = 140;
          return;
        }
        ipBoardPart.otherHeight = null;
        ipBoardPart.otherWidth = null;
      },
    },
    UPRIGHT: {
      label: 'Opstaande lay-out',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal
        ) {
          ipBoardPart.otherHeight = 100;
          ipBoardPart.otherWidth = 70;
          return;
        }
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
        ) {
          ipBoardPart.otherHeight = 140;
          ipBoardPart.otherWidth = 100;
          return;
        }
        ipBoardPart.otherHeight = null;
        ipBoardPart.otherWidth = null;
      },
    },
  };

  public static readonly CUSTOM_SIGN_ADHESIVE_OPTIONS = {
    _50_140: {
      label: '50 x 140 cm',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ) {
          ipBoardPart.otherWidth = 140;
          ipBoardPart.otherHeight = 50;
        } else {
          ipBoardPart.otherWidth = null;
          ipBoardPart.otherHeight = null;
        }
      },
      smallerLabel: '(50 x 70 per kant)',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-70-50.png`,
    },
    _70_180: {
      label: '70 x 180 cm',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ) {
          ipBoardPart.otherWidth = 180;
          ipBoardPart.otherHeight = 70;
        } else {
          ipBoardPart.otherWidth = null;
          ipBoardPart.otherHeight = null;
        }
      },
      smallerLabel: '(70 x 90 per kant)',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-90-70.png`,
    },
    _70_100: {
      label: '70 x 100 cm',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ) {
          ipBoardPart.otherWidth = 100;
          ipBoardPart.otherHeight = 70;
        } else {
          ipBoardPart.otherWidth = null;
          ipBoardPart.otherHeight = null;
        }
      },
      smallerLabel: '(70 x 50 per kant)',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-50-70.png`,
    },
    _100_140: {
      label: '100 x 140 cm',
      onSelect: (ipBoardPart: IPBoardPart) => {
        if (
          ipBoardPart.otherIPBoardPartType != null &&
          ipBoardPart.otherIPBoardPartType.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ) {
          ipBoardPart.otherWidth = 140;
          ipBoardPart.otherHeight = 100;
        } else {
          ipBoardPart.otherWidth = null;
          ipBoardPart.otherHeight = null;
        }
      },
      smallerLabel: '(100 x 70 per kant)',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-70-100.png`,
    },
  };

  public static readonly CUSTOM_SIGN_IP_DIMENSION_OPTIONS_ARRAY = Object.values(
    ClientIPBoardPartFormHelper.CUSTOM_SIGN_IP_DIMENSION_OPTIONS
  );
  public static readonly CUSTOM_SIGN_ADHESIVE_OPTIONS_ARRAY = Object.values(
    ClientIPBoardPartFormHelper.CUSTOM_SIGN_ADHESIVE_OPTIONS
  );

  static getInitialSelectedRightOption(
    ipBoardPart: IPBoardPart
  ): CustomSignOption {
    if (ipBoardPart.otherIPBoardPartType != null) {
      if (
        ipBoardPart.otherIPBoardPartType.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal
      ) {
        return this.getInitialOption70_100(ipBoardPart);
      }
      if (
        ipBoardPart.otherIPBoardPartType.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
      ) {
        return this.getInitialOption100_140(ipBoardPart);
      }
      if (
        ipBoardPart.otherIPBoardPartType.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
      ) {
        return this.getInitialOptionAdhesive(ipBoardPart);
      }
    }
    return null;
  }

  private static getInitialOption70_100(
    ipBoardPart: IPBoardPart
  ): CustomSignOption {
    if (ipBoardPart.otherHeight === 70 && ipBoardPart.otherWidth === 100) {
      return this.CUSTOM_SIGN_IP_DIMENSION_OPTIONS.LYING_DOWN;
    }
    if (ipBoardPart.otherHeight === 100 && ipBoardPart.otherWidth === 70) {
      return this.CUSTOM_SIGN_IP_DIMENSION_OPTIONS.UPRIGHT;
    }
    return null;
  }

  private static getInitialOption100_140(
    ipBoardPart: IPBoardPart
  ): CustomSignOption {
    if (ipBoardPart.otherHeight === 100 && ipBoardPart.otherWidth === 140) {
      return this.CUSTOM_SIGN_IP_DIMENSION_OPTIONS.LYING_DOWN;
    }
    if (ipBoardPart.otherHeight === 140 && ipBoardPart.otherWidth === 100) {
      return this.CUSTOM_SIGN_IP_DIMENSION_OPTIONS.UPRIGHT;
    }
    return null;
  }

  static getInitialOptionAdhesive(ipBoardPart: IPBoardPart): CustomSignOption {
    if (ipBoardPart.otherWidth === 140 && ipBoardPart.otherHeight === 50) {
      return this.CUSTOM_SIGN_ADHESIVE_OPTIONS._50_140;
    }
    if (ipBoardPart.otherWidth === 180 && ipBoardPart.otherHeight === 70) {
      return this.CUSTOM_SIGN_ADHESIVE_OPTIONS._70_180;
    }
    if (ipBoardPart.otherWidth === 100 && ipBoardPart.otherHeight === 70) {
      return this.CUSTOM_SIGN_ADHESIVE_OPTIONS._70_100;
    }
    if (ipBoardPart.otherWidth === 140 && ipBoardPart.otherHeight === 100) {
      return this.CUSTOM_SIGN_ADHESIVE_OPTIONS._100_140;
    }
    return null;
  }
}

export interface CustomSignOption {
  label: string;
  onSelect: (ipBoardPart: IPBoardPart) => void;
  smallerLabel?: string;
  previewUrl?: string;
}
